import { useSearchParams } from "react-router";
import { useBasketContext } from "../../hooks";
import { useStockListContext } from "./useStockListContext";
import { useStockListOrderSummaryProps } from "./useStockListOrderSummaryProps";

export const useStockListBasketValue = () => {
  const { supplierStorefront } = useStockListContext();
  const [{ order }] = useBasketContext();
  const [searchParams] = useSearchParams();

  const priceTierDiscounts =
    supplierStorefront?.VolumeDiscounts?.PriceTierDiscounts ?? [];

  const priceTierOrderRules =
    supplierStorefront?.FulfillmentType.OrderRules?.PriceTierOrderRules ??
    supplierStorefront?.OrderRules?.PriceTierOrderRules ??
    [];

  const minimumOrderPrice =
    supplierStorefront?.FulfillmentType.OrderRules?.minimumOrderPrice ??
    supplierStorefront?.OrderRules?.minimumOrderPrice ??
    0;

  const freeDeliveryBasketSubtotal =
    supplierStorefront?.FulfillmentType.freeDeliveryBasketSubtotal ?? null;

  const { apiValues } = useStockListOrderSummaryProps({
    order,
    deliveryChargeRules:
      supplierStorefront?.FulfillmentType.DeliveryChargeRules ?? [],
    deliveryCharge: supplierStorefront?.FulfillmentType.charge,
    fulfillmentTypeContainerDeliveryCharges:
      supplierStorefront?.FulfillmentType
        .FulfillmentTypeContainerDeliveryCharges,
    priceTierDiscounts,
    containerTypeDeliveryChargeRules:
      supplierStorefront?.FulfillmentType.ContainerTypeDeliveryChargeRules ??
      [],
    caseSizeRuleList: supplierStorefront?.CaseSizeRules.list ?? [],
    priceTierOrderRules,
    minimumOrderPrice,
    freeDeliveryBasketSubtotal,
  });

  const storefrontLink =
    searchParams.get("storefrontLink") ||
    searchParams.get("priceTierLink") ||
    searchParams.get("orderFlowToken");
  if (!storefrontLink) return;

  if (
    apiValues.price ||
    (apiValues.price === 0 && !!order?.OrderItems?.length)
  ) {
    return apiValues.price;
  }

  return;
};
